var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"w-full bg-[#FA650A] flex flex-row justify-center items-center rounded-[999px] text-white py-[16px] font-bold text-[20px] leading-[140%]",attrs:{"href":_vm.href},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }